if (!customElements.get('pdp-size-tools')) {
  customElements.define('pdp-size-tools', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.events = new AbortController();
      const listenerOptions = { signal: this.events.signal };
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-size-guide-open]');
      this.option = this.closest('[data-pdp-size-option]');
      // EasySize can insert its button after variant-picker, inside the block.
      this.finderScope = this.closest('.main-product__block-variant_picker')
        || this.closest('variant-picker')?.parentElement
        || this.option;
      this.moveFinder = () => {
        const finder = this.finderScope.querySelector('.easysize_button, .easysize_button__returning, .easysize_button__out_of_stock, #easysize_button');
        const slot = this.querySelector('[data-size-finder-slot]');
        if (finder?.closest('pdp-size-tools') && finder.closest('pdp-size-tools') !== this) return;
        if (finder && !slot.contains(finder)) slot.append(finder);
      };
      this.observer = new MutationObserver(this.moveFinder);
      this.observer.observe(this.finderScope, { childList: true, subtree: true });
      this.moveFinder();
      if (!this.dialog) return;
      this.opener.addEventListener('click', () => {
        // Native modal dialogs provide focus trapping and make the page inert.
        this.dialog.showModal();
        this.dialog.getBoundingClientRect();
        this.dialog.classList.add('is-open');
      }, listenerOptions);
      this.dialog.addEventListener('cancel', event => {
        event.preventDefault();
        this.close();
      }, listenerOptions);
      this.dialog.addEventListener('click', event => {
        event.stopPropagation();
        if (event.target.closest('[data-size-guide-close]')) this.close();
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
        }
        const tab = event.target.closest('[data-size-tab]');
        if (tab) this.selectTab(tab);
        if (event.target.closest('[data-size-unit]')) this.setUnit(!this.inches);
      }, listenerOptions);
      this.dialog.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-size-tab]');
        if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const tabs = [...this.dialog.querySelectorAll('[data-size-tab]')];
        let index = tabs.indexOf(tab);
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = tabs.length - 1;
        else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        this.selectTab(tabs[index]);
        tabs[index].focus();
      }, listenerOptions);
      this.setUnit(false);
    }
    selectTab(selected) {
      this.dialog.querySelectorAll('[data-size-tab]').forEach(tab => {
        tab.setAttribute('aria-selected', String(tab === selected));
        tab.tabIndex = tab === selected ? 0 : -1;
      });
      this.dialog.querySelectorAll('[data-size-panel]').forEach(panel => {
        panel.hidden = panel.dataset.sizePanel !== selected.dataset.sizeTab;
      });
      this.dialog.querySelectorAll('[data-size-tip]').forEach(tip => {
        tip.hidden = tip.dataset.sizeTip !== selected.dataset.sizeTab;
      });
    }
    setUnit(inches) {
      this.inches = inches;
      const formatter = new Intl.NumberFormat(this.dialog.dataset.locale || 'en', { maximumFractionDigits: 1 });
      this.dialog.querySelectorAll('[data-size-cm]').forEach(cell => {
        cell.textContent = cell.dataset.sizeCm.split('-').map(value => formatter.format(Number(value) / (inches ? 2.54 : 1))).join(' - ') + (inches ? ' in' : ' cm');
      });
      this.dialog.querySelectorAll('[data-size-unit]').forEach(button => {
        button.setAttribute('aria-checked', String(inches));
        button.setAttribute('aria-label', inches ? button.dataset.labelCm : button.dataset.labelIn);
      });
    }
    close() {
      if (this.closing) return;
      this.closing = true;
      this.dialog.classList.remove('is-open');
      this.closeTimer = setTimeout(() => {
        this.dialog.close();
        this.opener.focus();
        this.closing = false;
      }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 280);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
      this.closing = false;
      clearTimeout(this.closeTimer);
      if (this.dialog?.open) this.dialog.close();
      this.initialized = false;
    }
  });
}
